// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y__FhT{color:#000000}._uOtbR{color:#ffffff}.y__FhT,._uOtbR{padding:0;border:none;background:none;transition-property:border, background, color, opacity;transition-duration:0.2s;text-align:center;vertical-align:middle}.y__FhT svg,._uOtbR svg{width:17px;height:17px;font-size:17px;stroke-width:0.3}.y__FhT:hover,._uOtbR:hover{color:#767676}.tkksOY{line-height:0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `y__FhT`,
	"dark": `_uOtbR`,
	"icon": `tkksOY`
};
export default ___CSS_LOADER_EXPORT___;
